'use client';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';

type ProductWithDimensionsServicesProps = {
  className?: {
    wrapper?: string;
    item?: string;
  };
};

export function ProductWithDimensionsServices({ className }: ProductWithDimensionsServicesProps) {
  const product = useVariantsStore(s => s.product);
  const selectedServices = useVariantsStore(state => state.selectedServices);
  const updateSelectedServices = useVariantsStore(state => state.updateSelectedServices);
  const currency = useGlobalStore(state => state.generalLayout.currency);

  const services = product.services;

  if (!services) return null;

  return (
    services &&
    services.length > 0 && (
      <div className={cn('flex w-full items-start gap-1', 'ea-product-detail-services')}>
        <div className={cn('w-full', 'ea-product-detail-services__header')}>
          <div className={cn('flex flex-col gap-1', 'ea-product-detail-services__items')}>
            {services &&
              services.map(
                service =>
                  service.values?.map(value => {
                    // all already‐selected values for this service
                    const selectionsForService = selectedServices.filter(
                      s => s?.service_id === service.id,
                    );
                    const isSelected = selectionsForService.some(s => s.id === value?.id);

                    const handleCheckedChange = () => {
                      if (isSelected) {
                        // toggle off
                        updateSelectedServices({ ...value, service_id: service.id });
                        // } else if (selectionsForService.length < service.max_selections) {
                      } else if (selectionsForService.length < 99) {
                        // under limit: just add
                        updateSelectedServices({ ...value, service_id: service.id });
                      } else {
                        // at limit: remove oldest, then add new
                        const [oldest] = selectionsForService;
                        updateSelectedServices(oldest); // removes oldest
                        updateSelectedServices({ ...value, service_id: service.id }); // adds new
                      }
                    };

                    return (
                      <div
                        key={`${service.id}-${value.id}`}
                        className={cn(
                          'flex w-full flex-row items-center justify-between space-x-2 rounded-sm bg-input px-2 py-2 sm:w-[424px]',
                          'ea-product-detail-services__item-wrapper',
                          className?.item,
                        )}
                      >
                        <div
                          className={cn(
                            'flex items-center space-x-2',
                            'ea-product-detail-services__item-checkbox-wrapper',
                          )}
                        >
                          <Checkbox
                            id={`service-${service.id}-value-${value.id}`}
                            checked={isSelected}
                            onCheckedChange={handleCheckedChange}
                            className={cn('', 'ea-product-detail-services__item-checkbox-input')}
                          />
                          <Label
                            htmlFor={`service-${service.id}-value-${value.id}`}
                            className={cn('', 'ea-product-detail-services__item-label')}
                          >
                            {value.name}
                          </Label>
                        </div>
                        <p
                          className={cn(
                            'whitespace-nowrap text-sm font-semibold',
                            'ea-product-detail-services__item-price',
                          )}
                        >
                          ({parseFloat(value.price_with_vat.toString()).toFixed(2)} {currency})
                        </p>
                      </div>
                    );
                  }),
              )}
          </div>
        </div>
      </div>
    )
  );
}
